export const customersTranslation = {
  en: {
    "S.No": "S.No",
    Title: "Title",
    Sector: "Sector",
    Image: "Image",
    Status: "Status",
    "Created At": "Created At",
    Actions: "Actions",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    Customers: "Customers",
    "+ Add Customer": "+ Add Customer",
    "Search by title...": "Search by title...",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    "Sector (EN)": "Sector (EN)",
    "Sector (AR)": "Sector (AR)",
    Active: "Active",
    Inactive: "Inactive",
    "Edit Customer": "Edit Customer",
    "Add New Customer": "Add New Customer",
    "Update Customer": "Update Customer",
    "Add Customer": "Add Customer",
    "Are you sure you want to delete customer '{{title}}'?":
      "Are you sure you want to delete customer '{{title}}'?",
    Cancel: "Cancel",
    Delete: "Delete",
    "This action cannot be undone.": "This action cannot be undone.",
    "N/A": "N/A",
  },
  ar: {
    "S.No": "رقم",
    Title: "العنوان",
    Sector: "القطاع",
    Image: "الصورة",
    Status: "الحالة",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    Customers: "العملاء",
    "+ Add Customer": "+ إضافة عميل",
    "Search by title...": "البحث حسب العنوان...",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    "Sector (EN)": "القطاع (EN)",
    "Sector (AR)": "القطاع (AR)",
    Active: "نشط",
    Inactive: "غير نشط",
    "Edit Customer": "تعديل العميل",
    "Add New Customer": "إضافة عميل جديد",
    "Update Customer": "تحديث العميل",
    "Add Customer": "إضافة عميل",
    "Are you sure you want to delete customer '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف العميل '{{title}}'؟",
    Cancel: "إلغاء",
    Delete: "حذف",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    "N/A": "غير متوفر",
  },
};
